import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Button } from "../Button/Button";

export const StyledNavBarButton = styled(Button)<{
  $direction: "next" | "previous";
}>`
  position: absolute;
  margin-top: 1px;
  cursor: pointer;
  z-index: 2;
  background-image: none;

  ${(props) =>
    props.$direction === "previous" &&
    css`
      right: auto;
      left: 1px;
    `}

  ${(props) =>
    props.$direction === "next" &&
    css`
      right: 1px;
    `}
`;

interface StyledMonthInterface {
  $isCurrent: boolean;
  $isSelected: boolean;
  $isCurrentQuarter: boolean;
}

export const StyledMonths = styled.div`
  top: 30px;
  height: 230px;

  ${tw`
    tw-absolute
    tw-left-0
    tw-p-5
    tw-flex
    tw-flex-wrap
    tw-bg-page-paper-main
    tw-z-10
  `}
`;
export const StyledMonth = styled.div<StyledMonthInterface>`
  width: 26%;
  transition-duration: 0.3s;

  ${tw`
    tw-m-auto
    tw-cursor-pointer
    tw-rounded-xl
    tw-font-bold
    tw-text-sm
  `}

  ${(props) =>
    !props.$isSelected
      ? css`
          &:hover {
            background-color: var(--color-primary-300);
          }
        `
      : css`
          ${tw`tw-text-theme-100`}
          background-color: var(--color-primary);
        `}

   ${(props) =>
    props.$isCurrent &&
    !props.$isSelected &&
    css`
      ${tw`tw-text-primary`}
    `}

   ${(props) =>
    props.$isCurrent &&
    props.$isSelected &&
    css`
      color: var(--color-theme-100);
    `}

   ${(props) =>
    props.$isCurrentQuarter &&
    css`
      background-color: var(--color-primary-300);
    `}
`;

export const StyledYearMonthPicker = styled.div`
  display: table-caption;
  margin-bottom: 0.5rem;
  padding: 0 0.5rem;

  ${tw`tw-text-center tw-text-theme-900`}

  &> div {
    font-weight: 500;
    font-size: 1.15rem;
  }
`;

export const StyledYearMonthPickerNavBar = styled.div`
  width: auto;
  margin: 0 auto;
`;

export const StyledYearMonthPickerNavBarItem = styled.span`
  ${tw`tw-px-4 tw-cursor-pointer`}
  transition-duration: 0.3s;
  display: inline-block;

  &:hover {
    background-color: var(--color-primary-300);
    border-radius: 15px;
  }
`;

StyledNavBarButton.displayName = "StyledNavBarButton";
StyledMonths.displayName = "StyledMonths";
StyledMonth.displayName = "StyledMonth";
